export default "__VITE_ASSET__BhRDgoC8__"